import { StyledArrowButton } from './ArrowButton.styles';
import IconArrowLeftDark from 'images/icons/arrow-left-dark-grey.svg';
import IconArrowRightDark from 'images/icons/arrow-right-dark-grey.svg';

interface ArrowButtonProps {
  left?: boolean;
  onClick: () => void;
  disabled: boolean;
  position?: 'left' | 'right';
}

const ArrowButton = ({ left, onClick, disabled, position }: ArrowButtonProps) => {
  return (
    <StyledArrowButton
      aria-label={left ? 'Previous page' : 'Next page'}
      onClick={onClick}
      type="button"
      disabled={disabled}
      isDisabled={disabled}
      position={position}
      tabIndex={-1}
    >
      <img src={left ? IconArrowLeftDark : IconArrowRightDark} width="16px" height="16px" alt="" />
    </StyledArrowButton>
  );
};

export default ArrowButton;
